import { Reveal } from "@/components/Reveal";
import { SectionHeader } from "@/components/SectionHeader";
import { SKILL_GROUPS } from "@/data/content";
import { ShieldCheck, Terminal, Code2, Database, Server, Network } from "lucide-react";

const ICONS = { ShieldCheck, Terminal, Code2, Database, Server, Network };

export const Skills = () => (
    <section id="skills" data-testid="skills-section" className="scroll-mt-20 border-t border-white/5 bg-surface/30 py-24 md:py-32">
        <div className="mx-auto max-w-7xl px-5 sm:px-8">
            <SectionHeader
                chapter="02"
                kicker="Capabilities"
                title="Skills & Tools"
                testId="skills-heading"
            />

            <div className="grid grid-cols-1 gap-6 md:grid-cols-2 lg:grid-cols-3">
                {SKILL_GROUPS.map((group, i) => {
                    const Icon = ICONS[group.icon];
                    return (
                        <Reveal key={group.title} delay={(i % 3) * 0.1}>
                            <article
                                data-testid={`skill-group-${group.title.toLowerCase().replace(/\s+/g, "-")}`}
                                className="group h-full border border-white/10 bg-surface/70 p-7 transition-[border-color,box-shadow] duration-500 hover:border-neon/40 hover:shadow-[0_0_28px_rgba(0,255,102,0.08)]"
                            >
                                <div className="mb-5 flex items-center gap-3">
                                    <span className="flex h-10 w-10 items-center justify-center border border-neon/30 bg-neon/5 text-neon">
                                        <Icon size={18} strokeWidth={1.5} />
                                    </span>
                                    <h3 className="font-display text-lg font-bold tracking-tight text-zinc-100">
                                        {group.title}
                                    </h3>
                                </div>
                                <ul className="flex flex-wrap gap-2">
                                    {group.skills.map((skill) => (
                                        <li
                                            key={skill}
                                            data-testid={`skill-badge-${skill.toLowerCase().replace(/[^a-z0-9]+/g, "-")}`}
                                            className="cursor-default border border-white/10 bg-black/30 px-3 py-1.5 font-mono2 text-xs text-zinc-300 transition-[border-color,color,background-color] duration-300 hover:border-neon/50 hover:bg-neon/5 hover:text-neon"
                                        >
                                            {skill}
                                        </li>
                                    ))}
                                </ul>
                            </article>
                        </Reveal>
                    );
                })}
            </div>
        </div>
    </section>
);
